export default __webpack_public_path__ + "static/media/CheckStep-Not-Eligible.6b7a50cd.svg";